/* Tecán motion layer: inertia scroll (Lenis), masked line reveals, parallax.
   Fully disabled under prefers-reduced-motion; mobile keeps native scroll. */
(function () {
  'use strict';

  /* 0. Sticky header height on phones → --tecan-header-h (pinned stages size themselves under it) */
  (function () {
    var gs = Array.prototype.slice.call(document.querySelectorAll('.shopify-section-group-header-group')); /* announcement bar + header (siblings, no wrapper) */
    if (!gs.length) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function set() {
      var total = 0; gs.forEach(function (g) { total += g.offsetHeight; });
      var root = document.documentElement.style;
      /* header group is sticky on every viewport now (2026-09-09): stages size themselves under it */
      root.setProperty('--tecan-ann-h', (gs.length > 1 ? gs[0].offsetHeight : 0) + 'px');
      root.setProperty('--tecan-header-h', total + 'px');
    }
    set();
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(set); gs.forEach(function (g) { ro.observe(g); }); }
    if (mq.addEventListener) mq.addEventListener('change', set);
    window.addEventListener('load', set);
  })();

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  /* 1. Inertia scroll — desktop only, native scroll stays intact on touch */
  function initLenis() {
    if (typeof Lenis === 'undefined') return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    var lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.tecanLenis = lenis; /* other scripts (process settle assist) scroll through Lenis so it does not fight them */
    /* Pause inertia scroll while the cart drawer is open: Lenis would otherwise move the page under the drawer and
       swallow the wheel meant for the item list (the drawer itself carries data-lenis-prevent for native scrolling) */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      var sync = function () { if (drawer.classList.contains('active')) lenis.stop(); else lenis.start(); };
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      sync();
    }
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }

  /* 2. Masked line reveals — split target text into lines, slide each up with stagger */
  var REVEAL_TARGETS = [
    '.tecan-hero__heading',
    '.banner__heading',
    '.title-wrapper-with-link .title',
    '.tecan-serves__heading',
    '.newsletter__wrapper .h1, .newsletter__wrapper h2',
    '.collection-hero__title',
    '.product__title h1'
  ].join(',');

  function splitLines(el) {
    if (el.dataset.tecanSplit) return;
    el.dataset.tecanSplit = '1';
    /* Keep a11y prefixes (e.g. "Collection:") out of the visible split text */
    var hiddenText = '';
    el.querySelectorAll('.visually-hidden').forEach(function (h) {
      hiddenText += h.textContent;
      h.remove();
    });
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var spans = words.map(function (w) {
      var s = document.createElement('span');
      s.textContent = w + ' ';
      s.style.display = 'inline-block';
      el.appendChild(s);
      return s;
    });
    /* Group words into visual lines by offsetTop, wrap each line in a mask */
    var lines = [];
    var current = [], top = null;
    spans.forEach(function (s) {
      if (top === null || Math.abs(s.offsetTop - top) < 4) { current.push(s); top = top === null ? s.offsetTop : top; }
      else { lines.push(current); current = [s]; top = s.offsetTop; }
    });
    if (current.length) lines.push(current);
    el.textContent = '';
    if (hiddenText) {
      var vh = document.createElement('span');
      vh.className = 'visually-hidden';
      vh.textContent = hiddenText;
      el.appendChild(vh);
    }
    lines.forEach(function (lineWords, i) {
      var mask = document.createElement('span');
      mask.className = 'tecan-line-mask';
      var line = document.createElement('span');
      line.className = 'tecan-line';
      line.style.transitionDelay = (i * 90) + 'ms';
      line.textContent = lineWords.map(function (s) { return s.textContent; }).join('').replace(/\s+$/, '');
      mask.appendChild(line);
      el.appendChild(mask);
      if (i < lines.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function initReveals() {
    var els = document.querySelectorAll(REVEAL_TARGETS);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tecan-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.35 });
    els.forEach(function (el) {
      splitLines(el);
      el.classList.add('tecan-reveal');
      io.observe(el);
    });
    /* Safety nets: reveal in-view targets immediately (no IO wait), and if the
       observer never fires (broken/blocked), reveal everything after 2.5s so
       content can never be stuck hidden. */
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) {
        requestAnimationFrame(function () { el.classList.add('tecan-revealed'); });
      }
    });
    setTimeout(function () {
      var anyRevealed = document.querySelector('.tecan-revealed');
      if (!anyRevealed) els.forEach(function (el) { el.classList.add('tecan-revealed'); });
    }, 2500);
  }

  /* 3. Parallax — media drifts slower than the page */
  function initParallax() {
    var items = [];
    document.querySelectorAll('.tecan-hero__poster, .tecan-hero__video').forEach(function (el) {
      items.push({ el: el, depth: 0.18 });
    });
    document.querySelectorAll('.banner__media img').forEach(function (el) {
      el.style.willChange = 'transform';
      el.style.scale = '1.12';
      items.push({ el: el, depth: 0.1 });
    });
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var progress = (r.top + r.height / 2 - vh / 2) / vh;
        it.el.style.transform = 'translateY(' + (progress * it.depth * -100) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function init() { initLenis(); initReveals(); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
